import BaseService from "../baseService";
class ChannelsSlack extends BaseService {
    constructor(id) {
        const resource = "channels-slack";
        let relationship = {
            sendMessage: "send-message",
            sendMessageFile: "send-message-file",
        };
        super(id, relationship, resource);
    }
}

export default (id) => new ChannelsSlack(id);
